import { useEffect, useState } from "react";
import { Card, Box } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import Typography from "@mui/material/Typography";
import axiosInstance from "../../axios.config";

export const TopPerformers = ({ courseId }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [courseName, setCourseName] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            if (!courseId) return;

            setLoading(true);

            try {
                const res = await axiosInstance.get(
                    `/UserCourseStep/GetTopStoresByCourse/${courseId}`
                );
                setCourseName(res.data.courseName);
                setData(res.data.data);
            } catch (err) {
                console.error(err);
                setData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [courseId]);

    // ---------------- UI ----------------

    if (!courseId) {
        return (
            <Card sx={{ height: 460, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Typography>Select a course</Typography>
            </Card>
        );
    }

    if (loading) {
        return (
            <Card sx={{ height: 460, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Typography>Loading...</Typography>
            </Card>
        );
    }

    if (!data || data.length === 0) {
        return (
            <Card sx={{ height: 460, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Typography>No data available</Typography>
            </Card>
        );
    }

    const yLabels = data.map(d => d.storeName);
    const values = data.map(d => d.completedCount);

    const colors = [
        "#4caf50", "#2196f3", "#ff9800", "#f44336", "#9c27b0",
        "#00acc1", "#8bc34a", "#ff5722", "#3f51b5", "#795548"
    ];

    return (
        <Card sx={{ height: 460, display: "flex", flexDirection: "column"}}>
            <Box p={2} >
                <Typography variant="h6" fontWeight={600} textAlign="center">
                    {courseName ? `${courseName} - Top 10 Stores` : "Top 10 Stores"}
                </Typography>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                >
                    <BarChart
                        layout="horizontal"
                        yAxis={[
                            {
                                data: yLabels,
                                scaleType: "band",
                                tickLabelStyle: {
                                    angle: 0,
                                    textAnchor: "end",
                                    fontSize: 11,
                                    whiteSpace: "nowrap",
                                },
                            },
                        ]}
                        xAxis={[
                            {
                                min: 0,
                                tickMinStep: 1,
                            },
                        ]}
                        series={values.map((v, i) => ({
                            data: values.map((_, j) => (j === i ? v : 0)),
                            label: yLabels[i],
                            color: colors[i % colors.length],
                            stack: "total",
                        }))}

                        tooltip={{
                            trigger: "item",
                            formatter: (params) => {
                                const value = params.value;
                                const index = params.dataIndex;
                                return `${yLabels[index]} → ${value} employees completed`;
                            },
                        }}
                        height={350}
                        margin={{ left: 130, right: 20, top: 20, bottom: 20 }}
                        slotProps={{
                            legend: {hidden:true},
                        }}
                        sx={{
                            "& .MuiBarElement-root": {
                                fill: (params) => colors[params.dataIndex % colors.length],
                            },
                        }}
                    />
                    {/* ✅ Plain label below X-axis */}
                    <Typography
                        variant="body2"
                        fontWeight={500}
                        sx={{ mt: 1 , ml:8}}
                    >
                        Number of Certified Employees
                    </Typography>
                </Box>
            </Box>
        </Card>
    );
};